import { Component, ViewChild, OnInit } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { EvaluacionService } from '../../services/evaluacion.service';
import { Evaluacion } from 'app/main/models/evaluacion.model';
import { Router,ActivatedRoute } from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { DialogBoxPrintComponentKri } from 'app/main/apps/kri/dialog/dialog-print-box.component';
import { AnalisisInherente } from 'app/main/models/analisis-inherente.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EvaluacionesListComponent} from './cards/evaluaciones-list.component'

const ELEMENT_DATA: Evaluacion[] = [];

@Component({
    selector   : 'evaluacion-kris-print',
    templateUrl: './evaluacion.component.html',
    styleUrls  : ['./evaluacion.component.scss']
})
export class EvaluacionKrisPrintComponent
{

    imprimible: boolean = true;
    deleteable: boolean = false;
    editable: boolean = false;

    displayedColumns: string[] = ['nombre','version','estructuraJerarquica','creador','dueno','fechaInicio','fechaFin','action'];
    dataSourcePreiniciado: Evaluacion[] = [];
    dataSourceIniciado: Evaluacion[] = [];
    dataSourceCompletado: Evaluacion[] = [];
    dataSourceAprobado: Evaluacion[] = [];
    dataSourceCerrado: Evaluacion[] = [];
    role = [];
    titulo = "Medidas de contingencia";
    evaluacion : Evaluacion = null;
    filterForm: FormGroup;
    estados: string[] = ["PRE_INICIADO","INICIADO","COMPLETADO","APROBADO","CERRADO"];

    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @ViewChild(EvaluacionesListComponent, {static : true}) child : EvaluacionesListComponent;

    constructor(public dialog: MatDialog,
                private _fuseProgressBarService: FuseProgressBarService,
                private storage: TokenStorageService,
                private service: EvaluacionService,
                public router: Router,
                private _snackBar: MatSnackBar,
                public translate: TranslateService,
                private route: ActivatedRoute,
                private _formBuilder: FormBuilder) {}

    ngOnInit() {

      this.filterForm = this._formBuilder.group({});
    }

    loadData():void{
      this.child.getElements(0);
    }

    print(evaluacion):void{

      this.service.get(evaluacion.id).pipe().subscribe(req => {
        this.evaluacion = new Evaluacion(req.body);
        this.loadEvalData();
        const dialogRef = this.dialog.open(DialogBoxPrintComponentKri, {
          panelClass: 'my-full-screen-dialog',
          width: '95%',
          maxWidth: '95%',
          data: {action:"Print", obj:this.evaluacion},
          autoFocus: false,
          disableClose: true
        });

      });
    }

    loadEvalData(){

      this.evaluacion.riesgos.forEach(riesgo => {

        if(riesgo.analisisInherente.length>0){
            riesgo.analisisInherente.forEach(ai => {
              if(riesgo.topAnalisisInherente==null){
                riesgo.topAnalisisInherente= ai;
              }else if(riesgo.topAnalisisInherente.exposicion<ai.exposicion){
                riesgo.topAnalisisInherente= ai;
              }
            });
        }else{
          riesgo.topAnalisisInherente = new AnalisisInherente({});
        }

        riesgo.analisisResidual.forEach(ar => {
          if(riesgo.topAnalisisResidual==null){
            riesgo.topAnalisisResidual= ar;
          }else if(riesgo.topAnalisisResidual.exposicion>ar.exposicion){
            riesgo.topAnalisisResidual= ar;
          }
        });


        riesgo.cantidadControles = 0;
        riesgo.analisisResidual.forEach(element => {
          if(element.control!=null && element.control!="")
            riesgo.cantidadControles +=1;
        });


      });
    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 3000,
      });
    }

    tieneUsuario(usuario,listaUsuarios):boolean{
      var tiene = false;
      listaUsuarios.forEach(element => {
         if(usuario===element.correoElectronico)
            tiene = true;
      });

      return tiene;
    }

}
